import axios from "axios";
import { createContext } from "react";

const SysadminAIAssistantTemplateContext = createContext();

export const SysadminAIAssistantTemplateContextProvider = ({ children }) => {
  const getAIAssistantTemplates = (skip, take) => {
    return axios.get(`/api/sysadmin/ai/assistant-templates?skip=${skip}&take=${take}`);
  };

  const getAIAssistantTemplate = (id) => {
    return axios.get("/api/sysadmin/ai/assistant-templates/" + id);
  };

  const createAIAssistantTemplate = (data) => {
    return axios.post("/api/sysadmin/ai/assistant-templates", data);
  };

  const updateAIAssistantTemplate = (data) => {
    return axios.put("/api/sysadmin/ai/assistant-templates/" + data.id, data);
  };

  const deleteAIAssistantTemplate = (id) => {
    return axios.delete("/api/sysadmin/ai/assistant-templates/" + id);
  };

  return (
    <SysadminAIAssistantTemplateContext.Provider
      value={{
        getAIAssistantTemplates,
        getAIAssistantTemplate,
        createAIAssistantTemplate,
        updateAIAssistantTemplate,
        deleteAIAssistantTemplate,
      }}
    >
      {children}
    </SysadminAIAssistantTemplateContext.Provider>
  );
};

export default SysadminAIAssistantTemplateContext;
